module.exports = __webpack_public_path__ + "img/marker_orange.e72f36e7.svg";